"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteLootShopCategoryResponseToJSON = exports.DeleteLootShopCategoryResponseFromJSONTyped = exports.DeleteLootShopCategoryResponseFromJSON = void 0;
function DeleteLootShopCategoryResponseFromJSON(json) {
    return DeleteLootShopCategoryResponseFromJSONTyped(json, false);
}
exports.DeleteLootShopCategoryResponseFromJSON = DeleteLootShopCategoryResponseFromJSON;
function DeleteLootShopCategoryResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'success': json['success'],
        'message': json['message'],
    };
}
exports.DeleteLootShopCategoryResponseFromJSONTyped = DeleteLootShopCategoryResponseFromJSONTyped;
function DeleteLootShopCategoryResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'success': value.success,
        'message': value.message,
    };
}
exports.DeleteLootShopCategoryResponseToJSON = DeleteLootShopCategoryResponseToJSON;
